import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { RememberFeature } from './feature-state.actions';
import { Feature } from '../models/feature.model';
export class FeatureStateModel {
  readonly features: Feature[];
}

@State<FeatureStateModel>({
  name: 'features',
  defaults: {
    features: []
  }
})
@Injectable()
export class FeatureState {
  @Selector()
  static getFeatures(state: FeatureStateModel): Feature[] {
    return state.features;
  }

  @Action(RememberFeature)
  rememberFeature(
    context: StateContext<FeatureStateModel>,
    action: RememberFeature
  ): void {
    let currentFeatures = context.getState().features.slice(0);
    currentFeatures = currentFeatures.filter(
      (f) => f.name !== action.payload.name
    );
    currentFeatures.push(action.payload);
    context.setState({
      features: currentFeatures
    });
  }
}
